import API from "../../api/api";
// import Auth from '../../auth.js';
import { Link } from "react-router-dom";
import React, { Component } from "react";
import "../../styles/css/users/signup.css";
// import Card from '@material-ui/core/Card';
import Select from "@material-ui/core/Select";
import { Header, Footer } from "../../components";
import MenuItem from "@material-ui/core/MenuItem";
import States from "../../components/States/States";
import TextField from "@material-ui/core/TextField";
// import Checkbox from '@material-ui/core/Checkbox';
// import CardContent from '@material-ui/core/CardContent';
// import HighlightOffIcon from '@material-ui/icons/HighlightOff';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import ErrorOutileIcon from "@material-ui/icons/ErrorOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import SuccessImage from "../../Images/Success.svg";

import "filepond/dist/filepond.min.css";
import { Typography } from "@material-ui/core";

import { FilePond, File, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType
);

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      designation: "",
      email: "",
      name: "", // company name
      einNo: null,
      license_no: "",
      password: "",
      password2: "",
      mobile_no: "",
      address: "",
      state: "null",
      zipcode: "",
      imgUrl: "url",
      userType: 4,
      city: "",
      ext: "",
      signature: [],
      equipments: [],

      firstnameEmpty: false,
      lastnameEmpty: false,
      designationEmpty: false,
      emailEmpty: false,
      nameEmpty: false,
      einNoEmpty: false,
      addressEmpty: false,
      passwordEmpty: false,
      password2Empty: false,
      mobile_noEmpty: false,
      stateEmpty: false,
      zipCodeEmpty: false,
      cityEmpty: false,
      extEmpty: false,
      // signatureEmpty: false,
      equipmentsEmpty: false,
      licenseEmpty: false,

      mobile_noMinus: false,
      license_noMinus: false,
      zipCodeMinus: false,
      extMinus: false,
      einMinus: false,

      emailValid: false,

      isCreationLoading: false,
      isSubmitted: false,
      submitError: "",
      userCreationSuccess: false,
      passwordNotMatched: false,

      passwordValid: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectUserStateHandle = this.selectUserStateHandle.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState(
      {
        [name]: value,
      },
      () => this.checkMinus(name, value)
    );
  }

  checkMinus = (name, value) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (name === "zipcode" && value !== null && value < 0) {
      this.setState({ zipCodeMinus: true });
    } else if (name === "zipcode" && value !== null && value >= 0) {
      this.setState({ zipCodeMinus: false });
    }
    if (name === "mobile_no" && value !== null && value < 0) {
      this.setState({ mobile_noMinus: true });
    } else if (name === "mobile_no" && value !== null && value >= 0) {
      this.setState({ mobile_noMinus: false });
    }
    if (
      (name === "mobile_no" && value !== null && value === "") ||
      (name === "mobile_no" && value.length < 10) ||
      (name === "mobile_no" && value.length > 10)
    ) {
      this.setState({ mobile_noEmpty: true });
    } else if (
      (name === "mobile_no" && value !== null && value !== "") ||
      (name === "mobile_no" && value.length === 10)
    ) {
      this.setState({ mobile_noEmpty: false });
    }

    if (name === "license_no" && value !== null && value < 0) {
      this.setState({ license_noMinus: true });
    } else if (name === "license_no" && value !== null && value >= 0) {
      this.setState({ license_noMinus: false });
    }

    if (name === "license_no" && value !== null && value === "") {
      this.setState({ licenseEmpty: true });
    } else if (name === "license_no" && value !== null && value !== "") {
      this.setState({ licenseEmpty: false });
    }

    if (name === "ein" && value !== null && value < 0) {
      this.setState({ einMinus: true });
    } else if (name === "ein" && value !== null && value >= 0) {
      this.setState({ einMinus: false });
    }

    if (name === "first_name" && value !== null && value === "") {
      this.setState({ firstNameEmpty: true });
    } else if (name === "first_name" && value !== null && value !== "") {
      this.setState({ firstNameEmpty: false });
    }
    if (name === "last_name" && value !== null && value === "") {
      this.setState({ lastNameEmpty: true });
    } else if (name === "last_name" && value !== null && value !== "") {
      this.setState({ lastNameEmpty: false });
    }
    if (name === "name" && value !== null && value === "") {
      this.setState({ nameEmpty: true });
    } else if (name === "name" && value !== null && value !== "") {
      this.setState({ nameEmpty: false });
    }
    if (name === "designation" && value !== null && value === "") {
      this.setState({ designationEmpty: true });
    } else if (name === "designation" && value !== null && value !== "") {
      this.setState({ designationEmpty: false });
    }
    if (name === "email" && value !== null && value === "") {
      this.setState({ emailEmpty: true });
    } else if (name === "email" && value !== null && value !== "") {
      this.setState({ emailEmpty: false });
    }
    //====== email pattern validation ========================//
    // if (name === "email" && value !== "" && !pattern.test(value)) {
    //   this.setState({ emailValid: true });
    // } else if (name === "email" && value !== "" && pattern.test(value)) {
    //   this.setState({ emailValid: false });
    // }

    if (name === "ext" && value !== null && value === "") {
      this.setState({ extEmpty: true });
    } else if (name === "ext" && value !== null && value !== "") {
      this.setState({ extEmpty: false });
    }
    if (name === "ext" && value !== null && value < 0) {
      this.setState({ extMinus: true });
    } else if (name === "ext" && value !== null && value > 0) {
      this.setState({ extMinus: false });
    }
    if (name === "address" && value !== null && value === "") {
      this.setState({ addressEmpty: true });
    } else if (name === "address" && value !== null && value !== "") {
      this.setState({ addressEmpty: false });
    }
    if (name === "city" && value !== null && value === "") {
      this.setState({ cityEmpty: true });
    } else if (name === "city" && value !== null && value !== "") {
      this.setState({ cityEmpty: false });
    }

    if (name === "zipcode" && value !== null && value === "") {
      this.setState({ zipCodeEmpty: true });
    } else if (name === "zipcode" && value !== null && value !== "") {
      this.setState({ zipCodeEmpty: false });
    }

    if (name === "state" && value === null) {
      this.setState({ stateEmpty: true });
    } else if (name === "state" && value !== null) {
      this.setState({ stateEmpty: false });
    }
    if (name === "equipments" && value.length <= 0) {
      this.setState({ equipmentsEmpty: true });
    } else if (name === "equipments" && value.length > 0) {
      this.setState({ equipmentsEmpty: false });
    }
    if (
      (name === "password2" &&
        value !== null &&
        value !== this.state.password) ||
      (name === "password2" && value !== null && value !== this.state.password2)
    ) {
      this.setState({ passwordNotMatched: true });
    } else if (
      (name === "password2" &&
        value !== null &&
        value === this.state.password) ||
      (name === "password2" && value !== null && value === this.state.password2)
    ) {
      this.setState({ passwordNotMatched: false });
    }
  };
  removeTag = (i) => {
    const newequipments = [...this.state.equipments];
    newequipments.splice(i, 1);
    this.setState({ equipments: newequipments });
  };

  inputKeyDown = (e) => {
    const val = e.target.value;
    if (e.key === "Enter" && val) {
      if (
        this.state.equipments.find(
          (tag) => tag.toLowerCase() === val.toLowerCase()
        )
      ) {
        return;
      }
      this.setState({ equipments: [...this.state.equipments, val] });
      this.tagInput.value = null;
    } else if (e.key === "Backspace" && !val) {
      this.removeTag(this.state.equipments.length - 1);
    }
  };

  selectUserStateHandle(event) {
    this.setState({ state: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    window.scrollTo(0, 0);
    this.setState({ isCreationLoading: true });

    const Userdata = {
      name: this.state.name,
      email: this.state.email,
      einNo: this.state.einNo,
      password: this.state.password,
      password2: this.state.password2,
      mobile_no: this.state.mobile_no,
      address: this.state.address,
      state: this.state.state,
      zipCode: this.state.zipCode,
      city: this.state.city,
      ext: this.state.ext,
      signature: this.state.signature,
      equipments: this.state.equipments,
      license_no: this.state.license_no,
    };

    Object.keys(Userdata).forEach((key) => {
      if (Userdata[key] === "") {
        this.setState({
          [`${key}Empty`]: true,
        });
      } else {
        this.setState({
          [`${key}Empty`]: false,
        });
      }
    });
    if (this.state.state === "null") {
      this.setState({
        stateEmpty: true,
      });
    } else {
      this.setState({
        stateEmpty: false,
      });
    }

    const user = {
      first_name: this.state.firstname,
      last_name: this.state.lastname,
      designation: this.state.designation,
      email: this.state.email,
      name: this.state.name, // company name
      password: this.state.password,
      password_confirmation: this.state.password2,
      mobile_no: this.state.mobile_no,
      ein: this.state.einNo,
      // license_no: this.state.license_no === "" ? "null" : this.state.license_no,
      license_no: this.state.license_no,
      address: this.state.address,
      state: this.state.state,
      zipcode: this.state.zipcode,
      image_url: this.state.imgUrl,
      type: this.state.userType,
      city: this.state.city,
      ext: this.state.ext,
      equipments: this.state.equipments,
    };
    var formData_user = new FormData();
    if (this.state.signature.length > 0) {
      Object.keys(user).forEach((key) => {
        formData_user.append(key, user[key]);
      });
      this.state.signature.map((file, i) => {
        formData_user.append("signature[]", file, file.name);
        return 0;
      });
    } else {
      Object.keys(user).forEach((key) => {
        formData_user.append(key, user[key]);
      });
    }

    // Object.keys(user).forEach((key) => {
    //   formData_user.append(key, user[key]);
    // });
    // this.state.signature.map((file, i) => {
    //   formData_user.append("signature[]", file, file.name);
    //   return 0;
    // });
    if (
      this.state.firstname !== "" &&
      this.state.lastname !== "" &&
      this.state.designation !== "" &&
      this.state.email !== "" &&
      this.state.name !== "" &&
      this.state.einNo !== "" &&
      this.state.password !== "" &&
      this.state.password2 !== "" &&
      this.state.mobile_no !== "" &&
      this.state.address !== "" &&
      this.state.city !== "" &&
      this.state.ext !== "" &&
      this.state.equipments !== [] &&
      this.state.license_no !== "" &&
      this.state.state !== "null" &&
      !(this.state.zipcode < 0) &&
      !(this.state.mobile_no < 0) &&
      !(this.state.einNo < 0) &&
      this.state.zipcode !== "" &&
      !this.state.passwordNotMatched
    ) {
      API.post("user", formData_user)
        .then((res) => {
          this.showCreationMessage(true);
          this.clearAllFields();
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          const resp = err.response.data;
          this.setState({
            isCreationLoading: false,
            submitError:
              resp.error.constructor === {}.constructor
                ? resp.error[Object.keys(resp.error)[0]]
                : resp.error,
          });
          this.showCreationMessage(false);
        });
    } else {
      this.setState({ isCreationLoading: false });
    }
  }

  showCreationMessage = (success) => {
    this.setState({
      isSubmitted: true,
      userCreationSuccess: success ? true : false,
    });
    // setTimeout(() => {
    //   this.setState({
    //     isSubmitted: false,
    //     userCreationSuccess: true,
    //   });
    //   if (success) {
    //     // window.location.href = "/browseguest/str";
    //     window.location.href = "/";
    //   }
    // }, 3000);
  };

  clearAllFields = () => {
    this.setState({
      firstname: "",
      lastname: "",
      designation: "",
      name: "",
      email: "",
      einNo: "",
      license_no: "",
      password: "",
      password2: "",
      mobile_no: "",
      address: "",
      state: "null",
      zipcode: "",
      imgUrl: "url",
      userType: 2,
      city: "",
      ext: "",
      signature: [],
      equipments: [],

      firstnameEmpty: false,
      lastnameEmpty: false,
      designationEmpty: false,
      nameEmpty: false,
      emailEmpty: false,
      einNoEmpty: false,
      addressEmpty: false,
      passwordEmpty: false,
      password2Empty: false,
      mobile_noEmpty: false,
      stateEmpty: false,
      zipCodeEmpty: false,
      cityEmpty: false,
      extEmpty: false,
      // signatureEmpty: false,
      equipmentsEmpty: false,
    });
  };

  render() {
    const { isSubmitted, userCreationSuccess, isCreationLoading } = this.state;

    return (
      <div className={`mainDiv`}>
        <Header />
        <div className="signInMain">
          <div className="landingMainHead landingMainHeadSign landingMainHeadReg">
            <div className="landingMain registerMain">
              <div className="breadCrubmContainer removePadding breadCrubmContainerSign">
                <div className="breadCrumb">
                  <Link to="/landing" className="prevLinks">
                    Home
                  </Link>
                  <span>&nbsp;&gt;&nbsp;</span>
                  <span className="currLink">Surveyor signup</span>
                </div>
              </div>
              <div className="landingMainLeftSign landingMainLeftReg">
                <div className="landingMainActives">
                  <p className="loginMainActivesTitle landingMainActivesTitleReg">
                    Signup to get started
                  </p>
                </div>
                <div className="logingFormMain registerFormMain">
                  <div className="overlayMessage_wrapper">
                    <div
                      style={
                        userCreationSuccess
                          ? { height: "660px", padding: "15px 15px" }
                          : { height: "0px", padding: "0px 15px" }
                      }
                      className="overlayMessage"
                    >
                      <img className="iconImage" src={SuccessImage} alt="" />
                      <h1>Pending Request !</h1>
                      <p>
                        We will get back to you via email, after our admin
                        approve your request
                      </p>

                      <span>
                        <Link to="/" className="">
                          Back to home
                        </Link>
                      </span>
                    </div>
                  </div>
                  {this.state.userCreationSuccess === false ? (
                    <form
                      onSubmit={this.handleSubmit}
                      onKeyPress={(event) => {
                        if (event.which === 13 /* Enter */) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <div className="formTwoInputs">
                        {/* First Name */}
                        <div className="formInputRow">
                          <TextField
                            id="firstname"
                            label="First name"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="firstname"
                            value={this.state.firstname}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.firstnameEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Name is required</span>
                          </div>
                        </div>
                        {/* Last Name */}
                        <div className="formInputRow">
                          <TextField
                            id="lastname"
                            label="Last name"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="lastname"
                            value={this.state.lastname}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.lastnameEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Last Name is required</span>
                          </div>
                        </div>
                      </div>
                      <div className="formTwoInputs">
                        {/* Email */}
                        <div className="formInputRowFull">
                          <TextField
                            id="email"
                            label="Email"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="email"
                            type="email"
                            value={this.state.email}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.emailEmpty ? "block" : "none",
                            }}
                          >
                            <span>Email cannot be empty</span>
                          </div>
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.emailValid ? "block" : "none",
                            }}
                          >
                            <span>Please enter valid email address</span>
                          </div>
                        </div>
                      </div>

                      <div className="formTwoInputs">
                        {/* Email */}
                        <div className="formInputRow">
                          <TextField
                            id="mobile_no"
                            label="Phone number"
                            className="fullWidth"
                            type="number"
                            fullWidth
                            margin="normal"
                            name="mobile_no"
                            value={this.state.mobile_no}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.mobile_noEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Please enter valid phone number</span>
                          </div>
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.mobile_noMinus
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                        </div>
                        {/* Phone Number */}
                        <div className="formInputRow">
                          <TextField
                            type="number"
                            id="ext"
                            label="Ext"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="ext"
                            value={this.state.ext}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.extEmpty ? "block" : "none",
                            }}
                          >
                            <span>Ext is required</span>
                          </div>

                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.extMinus ? "block" : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                        </div>
                      </div>

                      <div className="formOneInput">
                        {/* Company Name */}
                        <div className="formInputRowFull">
                          <TextField
                            id="name"
                            label="Company name"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="name"
                            value={this.state.name}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.nameEmpty ? "block" : "none",
                            }}
                          >
                            <span>Company name is required</span>
                          </div>
                        </div>
                      </div>
                      <div className="formTwoInputs">
                        {/* Designation */}
                        <div className="formInputRow">
                          <TextField
                            id="designation"
                            label="Title"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="designation"
                            value={this.state.designation}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.designationEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Designation is required</span>
                          </div>
                        </div>
                        {/* License Number */}
                        <div className="formInputRow">
                          <TextField
                            id="license_no*"
                            label="License number"
                            className="fullWidth"
                            type="text"
                            fullWidth
                            margin="normal"
                            name="license_no"
                            value={this.state.license_no}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.license_noMinus
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.licenseEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>License number is required.</span>
                          </div>
                        </div>
                      </div>
                      <div className="formOneInput">
                        <div className="formInputRowFull">
                          <TextField
                            id="address"
                            label="Address"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="address"
                            value={this.state.address}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.addressEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Address is required</span>
                          </div>
                        </div>
                      </div>
                      <div className="formOneInput">
                        <div className="formInputRowFull">
                          <TextField
                            id="city"
                            label="City"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="city"
                            value={this.state.city}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.cityEmpty ? "block" : "none",
                            }}
                          >
                            <span>City is required</span>
                          </div>
                        </div>
                      </div>

                      <div className="formTwoInputs">
                        <div className="formInputRow">
                          <Select
                            value={this.state.state}
                            onChange={this.selectUserStateHandle}
                            className={`fullWidth marginBotMin selectField`}
                            inputProps={{
                              name: "states",
                              id: "selectUserState",
                            }}
                            required
                          >
                            <MenuItem value={"null"}>Select State*</MenuItem>
                            {States.map((state) => {
                              return (
                                <MenuItem key={state.name} value={state.name}>
                                  {state.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.stateEmpty ? "block" : "none",
                            }}
                          >
                            <span>State is required</span>
                          </div>
                        </div>
                        <div className="formInputRow">
                          <TextField
                            id="zipcode"
                            label="Zip code"
                            className="fullWidth"
                            type="number"
                            fullWidth
                            margin="normal"
                            name="zipcode"
                            value={this.state.zipcode}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.zipCodeEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Zip code is required</span>
                          </div>
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.zipCodeMinus
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                        </div>
                      </div>
                      <div className="formTwoInputs">
                        <div className="formInputRow">
                          <TextField
                            id="password"
                            label="Password"
                            className="fullWidth"
                            fullWidth
                            margin="normal"
                            name="password"
                            type="password"
                            value={this.state.password}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.passwordEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Password is required</span>
                          </div>

                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.passwordValid
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Please add at least 6 charachter.</span>
                          </div>
                        </div>
                        <div className="formInputRow">
                          <TextField
                            id="password2"
                            label="Retype password"
                            className="fullWidth"
                            type="password"
                            fullWidth
                            margin="normal"
                            name="password2"
                            value={this.state.password2}
                            onChange={this.handleInputChange}
                            required
                          />
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.password2Empty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Password confirmation is required</span>
                          </div>
                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.passwordNotMatched
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Passwords are not matched!</span>
                          </div>
                        </div>
                      </div>

                      <div className="formOneInput">
                        <div className="formInputRowFull">
                          <div className="input-tag">
                            <ul className="input-tag__tags">
                              {this.state.equipments.map((tag, i) => (
                                <li key={tag}>
                                  {tag}
                                  <button
                                    type="button"
                                    onClick={() => {
                                      this.removeTag(i);
                                    }}
                                  >
                                    +
                                  </button>
                                </li>
                              ))}
                              <li className="input-tag__tags__input">
                                <input
                                  placeholder="Enter equipments*"
                                  type="text"
                                  onKeyDown={this.inputKeyDown}
                                  ref={(c) => {
                                    this.tagInput = c;
                                  }}
                                />
                              </li>
                            </ul>
                          </div>

                          <div
                            className="ErrorLog ErrorLogReg"
                            style={{
                              display: this.state.equipmentsEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Equipments are required</span>
                          </div>
                        </div>
                      </div>

                      <div className="formOneInput">
                        <div className="formInputRowFull">
                          <div className="fullWidth textLabel ">
                            Upload your signature
                          </div>
                          <FilePond
                            allowFileTypeValidation={true}
                            acceptedFileTypes={["image/png", "image/jpeg"]}
                            imagePreviewMaxHeight="128"
                            className="fullWidth"
                            ref={(ref) => (this.pond = ref)}
                            files={this.state.signature}
                            allowMultiple={true}
                            maxFiles={1}
                            name="files"
                            // acceptedFileTypes={props.fileTypes}
                            labelIdle="Drop your signature here"
                            onupdatefiles={(fileItems) => {
                              this.setState({
                                signature: fileItems.map(
                                  (fileItem) => fileItem.file
                                ),
                              });
                            }}
                          ></FilePond>
                        </div>
                      </div>
                      <button type="submit" className="loginBtn regBtn">
                        {isCreationLoading ? (
                          <CircularProgress className="circularColor1" />
                        ) : (
                          <div>
                            <span>Signup</span>
                          </div>
                        )}
                      </button>
                      <div
                        className="userCreationMessage messageDiv"
                        id="userCreationMessage"
                      >
                        {isSubmitted ? (
                          userCreationSuccess ? (
                            <div className="messageBody messageDivSub userCreationSuccessColor">
                              {/* <div className="messageAction">
                              <ErrorOutileIcon />
                            </div>
                            <div className="userCreationSuccess">
                              User has been created successfully
                            </div> */}
                            </div>
                          ) : (
                            <div className="messageBody messageDivSub userCreationFailColor">
                              <div className="messageAction">
                                <ErrorOutileIcon />
                              </div>
                              <div className="userCreationFail">
                                {/* The email has already been taken */}
                                {this.state.submitError}
                              </div>
                            </div>
                          )
                        ) : null}
                      </div>
                      <div className="registrationLinks2 registrationLinks2Mobile">
                        <span>Already have an account ?&nbsp;</span>
                        <Link to="/signin" className="registerLink">
                          Login here
                        </Link>
                      </div>
                    </form>
                  ) : null}

                  <div
                    className="messageBody messageDivSub userCreationSuccessColor regNotification"
                    style={
                      userCreationSuccess
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <div className="messageAction messageActionReg">
                      <ErrorOutileIcon />
                    </div>
                    <div className="userCreationSuccess">
                      Signup request will be sent to our Administrator, we will
                      get in touch with you soon via E-mail.
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="landingMainRight">
              <img src="/static/images/loging_home.svg" alt="loging_home" />
            </div> */}
            </div>
          </div>
        </div>
        <div className="signup-footer-wrapper">
          <Footer />
        </div>
      </div>
    );
  }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/pages/Users/SignupSurveyor.js